import { InventoryItem } from "@/components/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface InventoryState {
    isInventoryOpen: boolean;
    selectedInventoryItem: InventoryItem | null;
}

const initialState: InventoryState = {    
    isInventoryOpen: false,
    selectedInventoryItem: null,
}

export const inventorySlice = createSlice({
    name: 'inventory',
    initialState,
    reducers: {
        setIsInventoryOpen: (state, action: PayloadAction<boolean>) => {
            state.isInventoryOpen = action.payload;
        },
        setSelectedInventoryItem: (state, action: PayloadAction<InventoryItem | null>) => {
            state.selectedInventoryItem = action.payload;
        }
    }
});

export const { setIsInventoryOpen, setSelectedInventoryItem } = inventorySlice.actions;
export default inventorySlice.reducer;